<template>
    <FormSection title="Add Documents" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-3">
                <PatientDocument
                    :patient-id="referralId"
                    :application="application"
                    :provider-id="providerId"
                    :account-id="accountId"
                    :upload-document="uploadDocument"
                    :delete-document="deleteDocument"
                    :get-documents="getReferralDocuments"
                    :is-palliative="isPalliative"
                />
            </div>
            <footer class="d-flex justify-content-center pb-3">
                <button @click="closeAddDocumentsDialog()" type="button" class="btn btn-xs me-2 btn-outline-primary">
                    Close
                </button>
            </footer>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./AddDocument.ts" />
